import React from "react";
import { CircularProgress, Modal } from "@mui/material";
import ModalBox from "../../../../common/ModalBox";
import styled from "@emotion/styled";
import BanCodeModal from "./M_BanCode";
import BanCompetitorsModal from "./M_BanCompetitors";
import BanSubstringsModal from "./M_BanSubstrings";
import BanTopicsModal from "./M_BanTopics";
import BiasModal from "./M_Bias";
import CodeModal from "../prompt/M_Code";
import DeanonymizeModal from "./M_Deanonymize";
import FactualConsistencyModal from "./M_FactualConsistency";
import GibberishModal from "./M_Gibberish";
import JSONModal from "./M_JSON";
import LanguageSameModal from "./M_LanguageSame";
import LanguageModal from "./M_Language";
import MaliciousURLsModal from "./M_MaliciousURLs";
import NoRefusalModal from "./M_NoRefusal";
import ReadingTimeModal from "./M_ReadingTime";
import RegexModal from "./M_Regex";
import RelevanceModal from "./M_Relevance";
import SensitiveModal from "./M_Sensitive";
import SentimentModal from "./M_Sentiment";
import ToxicityModal from "./M_Toxicity";
import URLReachabilityModal from "./M_URLReachability";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 400px;
`;

function EditOutputScannerModal({ open, handleClose, zoneUid, currentKey }) {
  if (currentKey === "ban_code") {
    return <BanCodeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_competitors") {
    return <BanCompetitorsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_substrings") {
    return <BanSubstringsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_topics") {
    return <BanTopicsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "bias") {
    return <BiasModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "code") {
    return <CodeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "deanonymize") {
    return <DeanonymizeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "factual_consistency") {
    return <FactualConsistencyModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "gibberish") {
    return <GibberishModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "json") {
    return <JSONModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "language_same") {
    return <LanguageSameModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "language") {
    return <LanguageModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "malicious_urls") {
    return <MaliciousURLsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "no_refusal") {
    return <NoRefusalModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "reading_time") {
    return <ReadingTimeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "regex") {
    return <RegexModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "relevance") {
    return <RelevanceModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "sensitive") {
    return <SensitiveModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "sentiment") {
    return <SentimentModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "toxicity") {
    return <ToxicityModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "url_reachabitlity") {
    return <URLReachabilityModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else {
    return (
      <React.Fragment>
        <Modal
          open={open}
          onClose={(_, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
        >
          <ModalBox sx={{ width: "60vw" }} title="Edit Output Scanner" handleClose={handleClose}>
            <Root>
              <CircularProgress color="primary" />
            </Root>
          </ModalBox>
        </Modal>
      </React.Fragment>
    );
  }
}

export default EditOutputScannerModal;
